"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildUserPayload;

var _deepObjectChanges = _interopRequireDefault(require("deep-object-changes"));

var _stripCacheKeysFromData = _interopRequireDefault(require("@devsta/strip-cache-keys-from-data"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function stripEmptyStrings(object) {
  return Object.keys(object).reduce(function (newObject, key) {
    return _objectSpread({}, newObject, _defineProperty({}, key, object[key] || null));
  }, {});
}

function buildUserPayload(originalUser, newUser) {
  var saving = newUser.saving,
      error = newUser.error,
      socialProfiles = newUser.socialProfiles,
      imageFile = newUser.imageFile,
      strippedUser = _objectWithoutProperties(newUser, ["saving", "error", "socialProfiles", "imageFile"]);

  var normalisedUser = _objectSpread({}, strippedUser, {
    phoneNumber: strippedUser.phoneNumber || null,
    workNumber: strippedUser.workNumber || null,
    linkedInUrl: strippedUser.linkedInUrl || null,
    initialSetup: true
  });

  var payload = stripEmptyStrings((0, _stripCacheKeysFromData.default)(normalisedUser));
  return (0, _deepObjectChanges.default)(originalUser, payload);
}